
import { div, navigate, TileField, Title } from "lqx-react";
import * as React from "react";


export const SourcesList = div({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    width: '100%'
})

export const SourceTile = ({ source }) => {
  return (
    <Tile onClick={ () => navigate( source.id, 3 )} >
      <Title>{ source.name } </Title>
      <TileField label="Unresolved assets:">{ source.unresolvedAssets }</TileField>
    </Tile>
  );
};

const Tile = div({
    cursor: 'pointer',
    borderRadius: 3,
    minWidth : 280,
    height: 120,
    margin: 4,
    padding: 4,
    backgroundColor: 'white'
});